import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { fetchFileBlobUrl } from "@/lib/api";

// Loads a private image with the session header (no tokens in URLs).
export function AuthImage({ path, alt, className, testId }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let url = null;
    let alive = true;
    fetchFileBlobUrl(path)
      .then((u) => {
        url = u;
        if (alive) setSrc(u);
        else URL.revokeObjectURL(u);
      })
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (failed) {
    return (
      <div className={`${className} bg-slate-50 flex flex-col items-center justify-center text-xs text-muted-foreground`} data-testid={`${testId}-unavailable`}>
        <ImageOff className="h-6 w-6 mb-1 text-slate-300" />
        Imagen no disponible
      </div>
    );
  }
  if (!src) return <div className={`${className} bg-slate-100 animate-pulse`} data-testid={`${testId}-loading`} />;
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
}
